@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="formField"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="formField"></ng-container>
}

<ng-template #formField>
  <div class="container">
    @if (!hideIconSpace) {
      <mat-icon>{{ icon }}</mat-icon>
    }
    <mat-form-field color="accent">
      @if (showSpinner) {
        <mat-spinner matSuffix [diameter]="20" color="accent" class="suffix-icon"></mat-spinner>
      }
      @if (shouldTitlecaseLabel) {
        <mat-label>{{ label | titlecase }}</mat-label>
      }
      @if (!shouldTitlecaseLabel) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-select
        #select="matSelect"
        [formControl]="control"
        (selectionChange)="onEmitSelectionChange($event.value)"
        disableOptionCentering
        panelClass="dropDownSelect"
        panelWidth="auto">
        <mat-select-trigger>
          {{ control.value | findfromid: options }}
        </mat-select-trigger>
        @if (showBlankOption) {
          <!-- visually blank, so it's named for screen readers (otherwise announced as an empty option) -->
          <mat-option
            [value]="null"
            [attr.aria-label]="sysText.none_ariaLabel">
          </mat-option>
        }
        @for (option of options; track option.id) {
          <mat-option [value]="option.id">
            @if (shouldCapitalize) {
              <span>{{ option.description | capitalizefirst }}</span>
            }
            @if (!shouldCapitalize) {
              <span>{{ option.description }}</span>
            }
            @if (option.companyName) {
              <span class="caption option-info">{{option.companyName}}</span>
            }
            @if (option.isStock) {
              <span class="caption option-info">{{ "-- " + sysText.stock + " --"}}</span>
            }
            @if (option.optionInfo) {
              <span class="caption option-info">{{option.optionInfo}}</span>
            }
          </mat-option>
        }
      </mat-select>
      @if (showHintArea) {
        <mat-hint [ngClass]="{ highlight: isHintHighlighted, warn: isHintWarning }">{{ hint }}</mat-hint>
      }
      @if (control.errors?.msError) {
        <mat-error>{{ control.errors?.msError == msErrorKey ? customMsError : control.errors?.msError }}</mat-error>
      }
      @if (control.errors?.required) {
        <mat-error> {{ sysText.required | capitalizefirst }}</mat-error>
      }
    </mat-form-field>
    @if (info) {
      <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    }
  </div>
</ng-template>
